<template>
    <div id="main">
        <container-loader v-if="isLoading"/>
        <div class="page page-container">
            <h1 class="title">{{$t('autenticacao')}}</h1>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-8">
                        <div class="field has-addons">
                            <div class="control is-expanded">
                                <v-input 
                                    ref="tokenIntegracao"
                                    v-model="apiassclientesovisapipartner.token"
                                    placeholder="token-integracao"
                                    :maxlength="50"
                                    :title="'token-integracao'"
                                    :disabled="true"
                                    :uppercase="false"
                                />
                            </div>
                            <div class="controlpadding-label padding-label-custom">
                                <b-button
                                    @click="copiarAreaTransferencia()"
                                    icon-right="content-copy"
                                    v-tippy 
                                    :title="$t('copiar-area-transferencia')"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="column is-2">
                        <button
                            class="save-btn botao-acao"
                            type="button"
                            @click="gerarToken()">
                            {{ $t("gerar-token") }}
                        </button>
                    </div>
                    <div class="column is-2">
                        <button
                            class="save-btn botao-acao"
                            type="button"
                            :disabled="isNull(apiassclientesovisapipartner.token)"
                            @click="confirmarDelecaoToken()">
                            {{ $t("deletar-token") }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-container">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        WEB HOOK - {{$t('autenticacao')}}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="save-btn"
                        type="button"
                        :disabled="apiassclientesovisapipartner.situacao != 1"
                        @click="salvarWbAutenticacao"
                    >
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-3">
                        <vss-select
                            ref="situacaoSelect"
                            :searchable="false"
                            :options="metodoSelect"
                            v-model="apiwebhookautenticacao.metodo"
                            mlLabels
                            title="metodo-autenticacao"
                            @input="onMetodoChanged($event, false)"
                    />
                    </div>
                    <div class="column is-3">
                        <v-input 
                            ref="usuarioInputRef"
                            :maxlength="255"
                            :title="'usuario-cliente-key'"
                            placeholder="usuario"
                            v-model="apiwebhookautenticacao.usuario"
                            :disabled="apiwebhookautenticacao.metodo.id == 0 || apiwebhookautenticacao.metodo.id == 1"
                            :uppercase="false"
                            :required="apiwebhookautenticacao.metodo.id != 0 && apiwebhookautenticacao.metodo.id != 1"
                            :msg="'msg-campo-obrigatorio'"
                            invalidWhenDisabled
                            :invalid="isNull(apiwebhookautenticacao.usuario) && apiwebhookautenticacao.metodo.id != 0 && apiwebhookautenticacao.metodo.id != 1"
                        />
                    </div>
                    <div class="column is-3">
                        <v-input 
                            ref="senhaInputRef"
                            v-model="apiwebhookautenticacao.senha"
                            :maxlength="255"
                            :hideInfo="hide.hideInfo"
                            :infoIsHidden="hide.infoIsHidden"
                            :title="'senha-cliente-secret'"
                            placeholder="senha"
                            :disabled="apiwebhookautenticacao.metodo.id == 0 || apiwebhookautenticacao.metodo.id == 1"
                            :uppercase="false"
                            :required="apiwebhookautenticacao.metodo.id != 0 && apiwebhookautenticacao.metodo.id != 1"
                            :msg="'msg-campo-obrigatorio'"
                            invalidWhenDisabled
                            :invalid="isNull(apiwebhookautenticacao.senha) && apiwebhookautenticacao.metodo.id != 0 && apiwebhookautenticacao.metodo.id != 1"
                        />
                    </div>
                    <div class="column is-3">
                        <v-input 
                            ref="tokenInputRef"
                            v-model="apiwebhookautenticacao.token"
                            :maxlength="255"
                            :title="apiwebhookautenticacao.metodo.id == 2 ? 'scope' : 'token'"
                            :placeholder="apiwebhookautenticacao.metodo.id == 2 ? 'scope' : 'token'"
                            :disabled="apiwebhookautenticacao.metodo.id == 0"
                            :uppercase="false"
                            :required="apiwebhookautenticacao.metodo.id != 0"
                            :msg="'msg-campo-obrigatorio'"
                            invalidWhenDisabled
                            :invalid="isNull(apiwebhookautenticacao.token) && apiwebhookautenticacao.metodo.id != 0"
                        />
                    </div>
                    <div class="column is-3">
                        <v-input 
                            ref="tokenUrlInputRef"
                            v-model="apiwebhookautenticacao.tokenurl"
                            :maxlength="255"
                            :title="'token-url'"
                            :placeholder="'token-url'"
                            :uppercase="false"
                            :disabled="apiwebhookautenticacao.metodo.id != 2"
                            :required="apiwebhookautenticacao.metodo.id == 2"
                            :msg="isNull(apiwebhookautenticacao.tokenurl) ? 'msg-campo-obrigatorio' : 'url-invalida'"
                            :invalid="(isNull(apiwebhookautenticacao.tokenurl) || !checkUrl(apiwebhookautenticacao.tokenurl)) && apiwebhookautenticacao.metodo.id == 2"
                            invalidWhenDisabled
                        />
                    </div>
                    <div class="column is-10">
                        <div class="container">
                            <p class="text-header-cv">{{ "Header"}}</p>
                        </div>
                    </div>
                    <div class="column is-2 container-b-generate">
                        <button 
                            type="button" 
                            :disabled="apiassclientesovisapipartner.situacao != 1"
                            class="btn botao-generate-header" 
                            @click="addChaveValor()">
                            <p>
                                <svg class="svg-icons">
                                    <use :xlink:href="require('@/assets/img/icons/shape-plus.svg')+'#layer'">
                                    </use>
                                </svg>
                                {{$t('nova-header')}}
                            </p>
                        </button>
                    </div>
                    <div class="column is-5">
                        <div class="container">
                            <p class="text-header-cv">{{ $t("chave") }}</p>
                        </div>
                    </div>
                    <div class="column is-5">
                        <div class="container">
                            <p class="text-header-cv">{{ $t("valor") }}</p>
                        </div>
                    </div>
                    <div class="column is-10 n-data" v-if="apiwebhookautenticacao.headers.length < 1">
                        <empty-table-message 
                            :msg="'msg-no-results'"/>
                    </div>
                    <div class="column is-11 mcontainer" v-for="(vc, i) in apiwebhookautenticacao.headers" :key="i">
                        <div class="columns is-flex-wrap">
                            <div class=" column is-5 containercv">
                                <v-input 
                                    :maxlength="50"
                                    :uppercase="false"
                                    placeholder="chave"
                                    v-model="vc.chave"
                                />
                            </div>
                            <div class=" column is-5 containercv">
                                <v-input 
                                    :maxlength="50"
                                    :uppercase="false"
                                    placeholder="valor"
                                    v-model="vc.valor"
                                />
                            </div>
                            <div class=" column is-1 tool containercv">
                                <b-button
                                    :disabled="apiassclientesovisapipartner.situacao != 1"
                                    icon-right="delete"
                                    @click="removeChaveValor(i, vc)"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page page-container">
            <div class="listing-header">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        WEB HOOK - {{$t('gatilhos-execucao')}}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="save-btn"
                        type="button"
                        @click="salvarWbGatilhoExecucao()"
                        :disabled="listagatilho.length < 1 || apiassclientesovisapipartner.situacao != 1"
                    >
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="grupos">
                <div class="n-data">
                    <empty-table-message 
                        v-if="listagatilho.length < 1"
                        :msg="'msg-no-results'"/>
                </div>
                <div class="grupo" v-for="(vc, i) in listagatilho" :key="i">
                    <div class="grupo-container">
                        <div class="titulo-gp">
                            <div class="titulo-left">
                                <label 
                                    for="titulo-gp" 
                                    v-text="$t('gatilho')"/> 
                            </div>
                            <div class="titulo-right">
                                <button 
                                    class="edit-button" 
                                    type="button" 
                                    :disabled="apiassclientesovisapipartner.situacao != 1"
                                    @click="removeGatilho(i, vc)">
                                    {{ $t('excluir-gatilho') }}
                                </button>
                            </div>
                        </div>
                        <div class="columns is-flex-wrap">
                            <div class="column is-3">
                                <vss-select
                                    ref="entidadeSelect"
                                    :searchable="true"
                                    title="entidade"
                                    :options="entidadeSelect"
                                    v-model="vc.entidadeSelected"
                                    :search="buscarEntidades"
                                    @onChange="updateEntidade($event, vc)"
                                    :key="'entidade' + i"  
                                    />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    ref="metodohttpSelect"
                                    :searchable="false"
                                    :options="metodoHttpSelect"
                                    v-model="vc.metodohttp"
                                    mlLabels
                                    title="metodo-http"
                            />
                            </div>
                            <div class="column is-3">
                                <vss-select
                                    ref="acaoSelect"
                                    :searchable="false"
                                    mlLabels
                                    title="acao" 
                                    :options="acaoSelect"
                                    v-model="vc.acaoSelected"
                                    @onChange="updateAcao($event, vc)"
                                    :key="'acao' + i"
                                />
                            </div>
                            <div class="column is-3">
                                <v-input 
                                    ref="limiteTransmissaoInput"
                                    :maxlength="255"
                                    :title="'limite-por-transmissao'"
                                    placeholder='limite-por-transmissao'
                                    v-model="vc.limittransmissao"
                                    :uppercase="false"
                                    :required="true"
                                    :msg="isNull(vc.limittransmissao) ? 'msg-campo-obrigatorio' : 'limite-transmissao-invalida-maior-zero-gatilho'"
                                    :invalid="isNull(vc.limittransmissao) || vc.limittransmissao <= 0"
                                    :key="'limite-por-transmissao' + i"
                                    validchars="0123456789"
                                    tooltipLabel="msg-tooltip-limite-transmissao"
                                    tooltipSize="is-small"
                                />
                            </div>
                            <div class="column is-3 input-padding">
                                <div class="group-buttons">
                                    <b-button
                                        class="expanded-buttons"
                                        :type="!vc.enviadoobjeto ? 'is-primary' : ''"
                                        :outlined="vc.enviadoobjeto"
                                        @click="updateCheck(false, i)"
                                        :key="'b1c' + i"
                                    >
                                        <span>{{ $t("id") }}</span>
                                    </b-button>
                                    <b-button
                                        class="expanded-buttons"
                                        :type="vc.enviadoobjeto ? 'is-primary' : ''"
                                        :outlined="!vc.enviadoobjeto"
                                        @click="updateCheck(true, i)"
                                        :key="'b2c' + i">
                                        <span>{{ $t("entidade") }}</span>
                                    </b-button>
                                </div>
                            </div>
                            <div class="column is-9">
                                <v-input 
                                    ref="urlChamadaInput"
                                    :maxlength="255"
                                    :title="'url-de-chamada'"
                                    placeholder='url-de-chamada'
                                    v-model="vc.url"
                                    :uppercase="false"
                                    :required="true"
                                    :msg="isNull(vc.url) ? 'msg-campo-obrigatorio' : 'url-invalida'"
                                    :invalid="isNull(vc.url) || !checkUrl(vc.url)"
                                    :key="'url' + i"
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-b-generate">
                    <button 
                        type="button" 
                        :disabled="apiassclientesovisapipartner.situacao != 1"
                        class="btn botao-generate" 
                        @click="addGatilho()">
                        <p>
                            <svg class="svg-icons">
                                <use :xlink:href="require('@/assets/img/icons/shape-plus.svg')+'#layer'">
                                </use>
                            </svg>
                            {{$t('novo-gatilho')}}
                        </p>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ApiAssClienteSovisApiPartnerService from "@/services/ApiAssClienteSovisApiPartnerService";
import ApiWebHookAutenticacaoService from "@/services/ApiWebHookAutenticacaoService";
import ApiEntidadeService from "@/services/ApiEntidadeService";
import ApiWebHookGatilhoService from "@/services/ApiWebHookGatilhoService";
import ApiWebHookAutenticacaoHeaderService from "@/services/ApiWebHookAutenticacaoHeaderService";
import { mapState } from 'vuex';
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import ApiWebHookAutenticacaoValidation from "@/services/validations/ApiWebHookAutenticacaoValidation";
import HideInfo from "@/components/shared/HideInfo";

export default {
    computed: {
        ...mapState(['hide']),
        ...mapState(['tokenIntegracao']),
    }, 
    components: {
        ContainerLoader,
        HideInfo,
    },
    data() {
        return {
            serviceapiassclienteapi: new ApiAssClienteSovisApiPartnerService(this.$http, this.$router),
            serviceapiwebhookautenticacao: new ApiWebHookAutenticacaoService(this.$http, this.$router),
            serviceapientidade: new ApiEntidadeService(this.$http, this.$router),
            serviceapiwebhookgatilho: new ApiWebHookGatilhoService(this.$http, this.$router),
            serviceapiwebhookautenticacaoheader: new ApiWebHookAutenticacaoHeaderService(this.$http, this.$router),
            listagatilho: [],
            
            apiassclientesovisapipartner:{
                token: "",
            },
            apiwebhookautenticacao: {
                metodo: {id: 0, label: "sem-autenticacao"},
                usuario: null,
                senha: null,
                token: null,
                tokenurl: null,
                headers: [],
            },
            entidadeSelect: [],
            metodoSelect: [
                {id: 0, label: "sem-autenticacao"},
                {id: 1, label: "basic-auth"},
                {id: 2, label: "bearer-token"},
            ],
            metodoHttpSelect: [
                {id: 0, label: "POST"},
                {id: 1, label: "PUT"},
            ],
            acaoSelect: [
                {id: 0, label: "inserir-config"},
                {id: 1, label: "atualizar"},
                {id: 2, label: "deletar"},
            ],
            acaoSelected: {id: 0, label: "inserir-config"},
            isLoading: false,
            assCount: false,
            auteCount: false,
            gatCount: false,
            buscarApiAssClienteSovisApiPartnerWatch: false,
            buscarWhAutenticacaoWatch: false,
            buscarEntidadesWatch: false,
            buscarGatilhosWatch: false,
            validation: null,
            msgs: [],
        };
    },
    watch: {
        apiassclientesovisapipartner :{
            deep: true,
            handler: function() {
                if(this.buscarApiAssClienteSovisApiPartnerWatch){
                    this.$emit("isChangedAutenticacao", true);
                }
            }
        },
        apiwebhookautenticacao :{
            deep: true,
            handler: function() {
                if(this.buscarWhAutenticacaoWatch){
                    this.$emit("isChangedWhAutenticacao", true);
                }
            }
        },
        listagatilho :{
            deep: true,
            handler: function() {
                if(this.buscarEntidadesWatch && this.buscarGatilhosWatch){
                    this.$emit("isChangedWhGatilho", true);
                }
            }
        },
    },
    created() {
        this.validation = new ApiWebHookAutenticacaoValidation(this.msgs);

        this.carregarDados();
    },
    methods: {
        carregarDados () {
            this.buscarApiAssClienteSovisApiPartner();
            this.buscarWhAutenticacao();
            this.buscarEntidades();
        },
        buscarApiAssClienteSovisApiPartner(){
            this.isLoading = true;
            this.serviceapiassclienteapi
                .getByIdApiPartner(this.$route.params.id)
                .then(obj => {
                    this.mapApiAssClienteSovisApiPartner(obj.content)
                }).finally(() => {
                    this.$forceUpdate();
                    this.isLoading = false;
                    this.buscarApiAssClienteSovisApiPartnerWatch = true;
                    this.$emit("isChangedAutenticacao", false);
                });
        },
        mapApiAssClienteSovisApiPartner(obj){
            if(obj){
                this.apiassclientesovisapipartner.id = obj.id
                this.apiassclientesovisapipartner.idclientesovis = obj.idclientesovis
                this.apiassclientesovisapipartner.apipartnerid = obj.apipartnerid
                this.apiassclientesovisapipartner.situacao = obj.situacao
                this.apiassclientesovisapipartner.token = obj.tokenintegracao
            } else {
                this.apiassclientesovisapipartner = {}
            }
        },
        buscarWhAutenticacao(){
            this.isLoading = true;

            this.serviceapiwebhookautenticacao
                .getByIdApiPartner(this.$route.params.id)
                .then(obj => {
                    this.mapWhAutenticacao(obj.content)
                }) 
                .finally(()=>{
                    this.isLoading = false;
                    this.buscarWhAutenticacaoWatch = true;
                    this.$emit("isChangedWhAutenticacao", false);
                })
        },
        mapWhAutenticacao(obj){
            if(obj){
                this.apiwebhookautenticacao.id = obj.id;
                this.apiwebhookautenticacao.metodo = this.metodoSelect[obj.metodo];
                this.apiwebhookautenticacao.token = obj.token;
                this.apiwebhookautenticacao.tokenurl = obj.tokenurl;
                this.apiwebhookautenticacao.senha = obj.senha;
                this.apiwebhookautenticacao.usuario = obj.usuario;
                this.apiwebhookautenticacao.headers = obj.headers;
                this.apiwebhookautenticacao.idclientesovis = obj.idclientesovis;
                this.apiwebhookautenticacao.partnerid = obj.partnerid;
                this.apiwebhookautenticacao.situacao = obj.situacao;
                this.apiwebhookautenticacao.usuarioidlog =obj.usuarioidlog;
            }
        },
        buscarEntidades(limit = 1000, sr = '.*'){
            this.isLoading = true;
            this.serviceapientidade
                .findAllCombo(limit, sr)
                .then(obj => {
                    this.entidadeSelect =  this.mapEntidade(obj.content)
                })
                .finally(()=>{
                    this.isLoading = false;
                    this.buscarEntidadesWatch = true;
                    this.buscarGatilhos();
                })
        },
        mapEntidade(obj){
            return obj.map(r => {
                return {
                    id: r.id,
                    label: r.nome,
                    condicaoenvio: r.condicaoenvio,
                    condicaoerro: r.condicaoerro,
                    condicaosucesso: r.condicaosucesso
                };
            });
        },
        buscarGatilhos(){
            this.isLoading = true;
            this.listagatilho = []
            this.serviceapiwebhookgatilho
                .findAllGatilhos(this.$route.params.id)
                .then(obj => {
                    this.listagatilho = this.mapGatilhos(obj.content)
                }).finally(()=>{
                    this.isLoading = false;
                    this.buscarGatilhosWatch = true;
                    this.$emit("isChangedWhGatilho", false);
                })
        },
        mapGatilhos(obj){
            
            return obj.map(r => {
                return {
                    id: r.id,
                    entidadeSelected: r.apientidade 
                        ? {id: r.apientidade.id, label: r.apientidade.nome}
                        : this.entidadeSelect 
                            ? this.entidadeSelect[0]
                            : null,
                    enviadoobjeto: r.enviadoobjeto == 1 ? true : false,
                    limittransmissao: r.limittransmissao,
                    metodohttp: r.metodohttp == 'POST' ? this.metodoHttpSelect[0] : this.metodoHttpSelect[1],
                    acaoSelected: r.operacao == 'I' ? this.acaoSelect[0] : r.operacao == 'U' ? this.acaoSelect[1] : this.acaoSelect[2],
                    url: r.urlchamada,
                };
            });
        },
        gerarToken(){
            this.serviceapiassclienteapi
                .getByIdApiPartner(this.$route.params.id)
                .then(obj => {
                    this.mapApiAssClienteSovisApiPartner(obj.content)
                })                    
                .finally(() => {
                    //valida se existe integração e se situação é igual a 1
                    if(this.apiassclientesovisapipartner.id && this.apiassclientesovisapipartner.situacao == 1){
                        if(this.apiassclientesovisapipartner.token){
                            //Se existe token cadastrado
                            let message = this.$t('msg-confirmacao-novo-token');
                            this.$root.confirm({
                                message: message,
                                onConfirm: this.salvarTokenGerado,
                                onCancel: this.removePrompt,
                            });
                        } else {
                            //Se não existe token cadastrado
                            this.salvarTokenGerado();
                        }
                    } else {
                        this.$root.showMessage(
                            "error",
                            "msg-integracao-nao-cadastrada"
                        );
                        this.isLoading = false;
                    }
                });
        },
        //gera e salva o token
        salvarTokenGerado(){
            this.isLoading = true;
            this.serviceapiassclienteapi.gerarToken(this.mapToken(this.apiassclientesovisapipartner))
                .then((value) => {
                    if (value.content === null) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-token-gerado-sucesso"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarApiAssClienteSovisApiPartner();
                    this.isLoading = false;
                });
        },
        //salva o token
        salvarToken(message = ""){
            this.isLoading = true;
            this.serviceapiassclienteapi.save(this.mapToken(this.apiassclientesovisapipartner))
                .then((value) => {
                    if (value.content === null) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            message
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarApiAssClienteSovisApiPartner();
                    this.isLoading = false;
                });
        },
        copiarAreaTransferencia(){
            try {
                this.selectText(this.$refs.tokenIntegracao.$refs.typed)
                var successful = document.execCommand('copy');

                if(successful){
                    this.$root.showMessage("success", "msg-sucesso-copiar-area-transferencia", true);
                } else {
                    this.$root.showMessage("alert", "msg-aviso-copiar-area-transferencia", true);
                }
            } catch (err) {
                this.$root.showMessage("error", "msg-erro-copiar-area-transferencia", true);
            }
        },
        selectText(element) {
            var range;
            if (document.selection) {
                range = document.body.createTextRange();
                range.moveToElementText(element);
                range.select();
            } else if (window.getSelection) {
                range = document.createRange();
                range.selectNode(element);
                window.getSelection().removeAllRanges();
                window.getSelection().addRange(range);
            }
        },
        mapToken(obj){
            return {
                id: obj.id,
                idclientesovis: obj.idclientesovis,
                apipartnerid: this.$route.params.id,
                tokenintegracao: obj.token,
                situacao: obj.situacao,
                usuarioidlog: obj.usuarioidlog ? obj.usuarioidlog : 0,
            }
        },
        deletarToken(){
            this.apiassclientesovisapipartner.token = null
            const sucessmessage = 'msg-token-deletado-sucesso'
            this.salvarToken(sucessmessage);
        },
        confirmarDelecaoToken(){
            let message = this.$t('msg-deletar-token');
            this.$root.confirm({
                message: message,
                onConfirm: this.deletarToken,
                onCancel: this.removePrompt,
            });
        },
        salvarWbAutenticacao(){
            const validacao = this.validation.validate(this.apiwebhookautenticacao, this.$refs, )

            if(this.apiwebhookautenticacao.metodo.id == 2 && !this.checkUrl(this.apiwebhookautenticacao.tokenurl)){
                this.$refs.tokenUrlInputRef.focusedOut = true;
                this.$root.showMessage("error", "url-invalida");
                this.isLoading = false;
                return;
            }

            if (validacao.validated) {
                this.isLoading = true;
                let tempSelecionados = this.mapOnSaveWbAutenticacao();
                    this.serviceapiwebhookautenticacao.save(tempSelecionados)
                        .then((value) => {
                            if (value.content === null) {
                                this.$root.showMessage("error", `${value.message}`, true);
                            } else {
                                this.$root.showMessage(
                                    "success",
                                    "msg-sucesso-salvar-autenticacao"
                                );
                            }
                        })
                        .catch((e) => {
                            this.$root.showMessage("alert", "msg-erro-load", true);
                        })
                        .finally(() => {
                            this.buscarWhAutenticacao();
                            this.isLoading = false;
                        });
            } else {
                validacao.msgs.map(m => {
                    this.$root.showMessage("alert", m, true);
                });
            }
        },
        mapOnSaveWbAutenticacao(){
            const headers = this.apiwebhookautenticacao.headers.map(e => {
                return {
                    id: e.id,
                    apiwebhookautenticacaoid: e.apiwebhookautenticacaoid,
                    chave: e.chave,
                    valor: e.valor,
                    situacao: e.situacao,
                    usuarioidlog: e.usuarioidlog ? e.usuarioidlog : 0,
                }
            });

            const wbAutenticacao = {
                id: this.apiwebhookautenticacao.id,
                idclientesovis: this.apiwebhookautenticacao.idclientesovis ? this.apiwebhookautenticacao.idclientesovis : 0,
                partnerid: this.apiwebhookautenticacao.partnerid ? this.apiwebhookautenticacao.partnerid : this.$route.params.id,
                metodo: this.apiwebhookautenticacao.metodo.id,
                usuario: this.apiwebhookautenticacao.metodo.id == 0 || this.apiwebhookautenticacao.metodo.id == 1 ? null : this.apiwebhookautenticacao.usuario,
                senha: this.apiwebhookautenticacao.metodo.id == 0 ||this. apiwebhookautenticacao.metodo.id == 1 ? null : this.apiwebhookautenticacao.senha,
                token: this.apiwebhookautenticacao.metodo.id == 0 ? null : this.apiwebhookautenticacao.token,
                tokenurl: this.apiwebhookautenticacao.metodo.id != 2 ? null : this.apiwebhookautenticacao.tokenurl,
                situacao: this.apiwebhookautenticacao.situacao,
                usuarioidlog: this.apiwebhookautenticacao.usuarioidlog ? this.apiwebhookautenticacao.usuarioidlog : 0,
                headers: headers
            }

            return wbAutenticacao;
        },
        salvarWbGatilhoExecucao(){
            this.isLoading = true;
            let tempSelecionados = this.mapOnSaveWbGatilhoExecucao();

            if(!this.validateAll(tempSelecionados)){
                this.isLoading = false;
                return;
            }

            this.serviceapiwebhookgatilho.insertBulk(tempSelecionados)
                .then((value) => {
                    if (value.content === null) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-sucesso-salvar-gatilhos"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarGatilhos()
                    this.isLoading = false;
                });
        },
        validateAll(all = []){
            let validateUrl = true;
            let validateLimit = true;
            let validateLimitIsZero = true;

            all.map((e, i) => {
                if(!this.checkUrl(e.urlchamada)){
                    this.$refs.urlChamadaInput[i].focusedOut = true;
                    validateUrl = false
                } 
                if(this.isNull(e.limittransmissao)){
                    validateLimit = false
                    this.$refs.limiteTransmissaoInput[i].focusedOut = true;
                } 

                if(!this.isNull(e.limittransmissao) && e.limittransmissao <= 0){
                    validateLimitIsZero = false;
                    this.$refs.limiteTransmissaoInput[i].focusedOut = true;
                }
            });

            if(!validateUrl){
                this.$root.showMessage("error", "url-invalida-gatilho");
                this.isLoading = false;
            }

            if(!validateLimit){
                this.$root.showMessage("error", "limite-transmissao-invalida-gatilho");
                this.isLoading = false;
            }
            
            if(!validateLimitIsZero){
                this.$root.showMessage("error", "limite-transmissao-invalida-maior-zero-gatilho");
                this.isLoading = false;
            }

            return validateUrl && validateLimit && validateLimitIsZero
        },
        checkUrl(str) {
            try {
                let url = new URL(str)
                return true;
            } catch(err) {
                return false
            }
        },
        mapOnSaveWbGatilhoExecucao(){
            return this.listagatilho.map(e => {
                return {
                    id: e.id,
                    apipartnerid: this.$route.params.id,
                    apientidadeid: e.entidadeSelected ? e.entidadeSelected.id : null,
                    urlchamada: e.url,
                    condicaoenvio: e.entidadeSelected.condicaoenvio,
                    condicaosucesso: e.entidadeSelected.condicaosucesso,
                    condicaoerro: e.entidadeSelected.condicaoerro,
                    limittransmissao: e.limittransmissao,
                    enviadoobjeto: e.enviadoobjeto ? 1 : 0,
                    metodohttp: e.metodohttp.label,
                    operacao: e.acaoSelected.id == 0 ? 'I' : e.acaoSelected.id == 1 ? 'U': 'D',
                    situacao: e.situacao,
                }
            });
        },
        updateAcao(val, vc){
            vc.acaoSelected = val;
        },
        updateEntidade(val, vc){
            vc.entidadeSelected = val;
        },
        addChaveValor() {
            this.apiwebhookautenticacao.headers.push({chave: "", valor: ""});
        },
        removeChaveValor(index, val){
            this.$root.confirm({
                message: this.$t("deseja-remover-header"),
                onConfirm: (_) => {
                    this.apiwebhookautenticacao.headers.splice(index, 1);
                    //VERIFICA SE O DADOS JA FOI PARA O SERVIDOR SE JA FOI ELE EDITA A SITUAÇÃO PARA 0 - NÃO EXISTE MAIS
                    //CONFORME FOI DECIDIDO OS REGISTROS AGORA VÃO SER DELETADOS
                    if(val.id != null){
                        this.deletarChaveValor(val)
                        //this.updateSituacaoChaveValor(val)
                        return;
                    }

                    this.$root.showMessage(
                        "success",
                        "msg-header-removida-sucesso"
                    );
                },
                onCancel: (_) => { return; },
            });
        },
        //CONFORME FOI DECIDIDO OS REGISTROS VÃO SER DELETADOS E NÃO MAIS ALTERADO A SITUAÇÃO, MANTER O MÉTODO APRA FUTURAS ALTERAÇÕES
        updateSituacaoChaveValor(obj){
            this.isLoading = true;
            obj.situacao = 0
            this.serviceapiwebhookautenticacaoheader.updateSituacao(obj)
                .then((value) => {
                    if (value.content === null) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-header-removida-sucesso"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarWhAutenticacao();
                    this.isLoading = false;
                });
        },
        deletarChaveValor(obj){
            this.isLoading = true;
            obj.situacao = 0
            this.serviceapiwebhookautenticacaoheader.delete(obj)
                .then((value) => {
                    if (value.status != 200) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-header-removida-sucesso"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("error", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarWhAutenticacao();
                    this.isLoading = false;
                });
        },
        addGatilho(){
            this.listagatilho.push({
                id: null,
                entidadeSelected: this.entidadeSelect 
                                    ? this.entidadeSelect[0]
                                    : null,
                acaoSelected: this.acaoSelect[0],
                limittransmissao: 1,
                metodohttp: this.metodoHttpSelect[0],
                tipo: true,
            })
        },
        removeGatilho(index, val){
            this.$root.confirm({
                message: this.$t("deseja-remover-gatilho"),
                onConfirm: (_) => {
                    this.listagatilho.splice(index, 1);
                    //VERIFICA SE O DADOS JA FOI PARA O SERVIDOR SE JA FOI ELE EDITA A SITUAÇÃO PARA 0
                    if (val.id != null) {
                        this.deleteGatilho(val)
                        return;
                    }

                    this.$root.showMessage(
                        "success",
                        "msg-sucesso-remover-gatilho"
                    );
                },
                onCancel: (_) => { return; },
            });
        },
        updateCheck(tipo, index){
            this.listagatilho[index].enviadoobjeto = tipo;
            this.$forceUpdate();
        },
        //CONFORME FOI DECIDIDO O GATILHO É DELETADO E NÃO MAIS ALTERADO A SITUAÇÃO, MANTER MÉTODO PARA FUTURAS ALTERAÇÕES
        updateSituacaoGatilho(obj){
            this.isLoading = true;
            const nobj = {
                id: obj.id,
                situacao: 0
            } 
            this.serviceapiwebhookgatilho.updateSituacao(nobj)
                .then((value) => {
                    if (value.content === null) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-sucesso-remover-gatilho"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarGatilhos()
                    this.isLoading = false;
                });
        },
        deleteGatilho(obj){
            this.isLoading = true;
            let nobj = {
                id: obj.id
            }
            this.serviceapiwebhookgatilho.delete(nobj)
                .then((value) => {
                    if (value.status != 200) {
                        this.$root.showMessage("error", `${value.message}`, true);
                    } else {
                        this.$root.showMessage(
                            "success",
                            "msg-sucesso-remover-gatilho"
                        );
                    }
                })
                .catch((e) => {
                    this.$root.showMessage("alert", "msg-erro-load", true);
                })
                .finally(() => {
                    this.buscarGatilhos()
                    this.isLoading = false;
                });
        },
        onMetodoChanged(val, selectMetodo = true){
            this.apiwebhookautenticacao.metodo = val
                ? this.metodoSelect.filter((v) => v.id == val.id)[0]
                : this.metodoSelect[0];

            this.apiwebhookautenticacao.usuario = this.apiwebhookautenticacao.metodo.id == 0 || this.apiwebhookautenticacao.metodo.id == 1 
                ? null 
                : this.apiwebhookautenticacao.usuario;

            this.apiwebhookautenticacao.senha = this.apiwebhookautenticacao.metodo.id == 0 ||this. apiwebhookautenticacao.metodo.id == 1 
                ? null 
                : this.apiwebhookautenticacao.senha;

            this.apiwebhookautenticacao.token = this.apiwebhookautenticacao.metodo.id == 0 
                ? null 
                : this.apiwebhookautenticacao.token;

            this.apiwebhookautenticacao.tokenurl = this.apiwebhookautenticacao.metodo.id != 2 
                ? null 
                : this.apiwebhookautenticacao.tokenurl;

            if(selectMetodo){
                this.$refs.usuarioInputRef.focusedOut = true;
                this.$refs.senhaInputRef.focusedOut = true;
                this.$refs.tokenInputRef.focusedOut = true;
                this.$refs.tokenUrlInputRef.focusedOut = true;
            }
        },
    }
};
</script>

<style lang="scss" scoped>
    .botao-acao {
        margin-top: 24px;
        width: 100%;
        padding: 0px !important;
        height: 36px;
    }
    .page {
        position: relative;
        padding: 30px !important;
        height: auto !important;
        background-color: $sovis-white;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
        border-radius: 2px;
        margin-bottom: 30px;
    }
    .container{
        height: 40px;
        min-width: 100%;
        background-color: $primary-color;
        border-radius: 5px;
        display: flex;
        align-items: center;
        .text-header-cv {
            justify-content: center;
            color: $sovis-white;
            width: 100%;
            display: flex;
        }
    }
    .tool{
        width: 40px !important;
    }
    .mcontainer{
        padding: 0.75rem;
        .containercv{
            width: 45.5%;
            //margin-right: 25px !important;
            display: inline-block !important;
        }
    }

        .grupo {
            width: 100%;
            background-color: #fefefe;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 15px;
            padding: 15px;
            border: solid 1px $table-border;
            border-radius: 3px;

            // @media only screen and (min-width: 760px) {
            //   .grupo-container{
            //     min-width: 700px;
            //   }
            // }
            .grupo-container{
                width: 100%;
            }
        }

        .titulo-gp {
            display: flex;
            width: 100%;
            text-transform: uppercase;

            .titulo-left, .titulo-right {
                display: flex;
                width: 50%;
            }

            .titulo-right {
                justify-content: flex-end;
            }

            label {
                font-style: normal;
                font-weight: 600;
                line-height: normal;
                font-size: 17px;
                color: $sovis-black;
            }

            .edit-button {
                box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
                width: 50%;
                color: $darker-gray-color;
                font-size: 12px;
                text-align: center;
                padding: 15px 40px;
                border: none;
                border-radius: 6px;
                font-weight: 600;
                @include exclude-button();
                padding: 5px 15px;

                &:not(:first-child) {
                    margin-left: 20px;
                }
            }
        }
        .botao-generate-header {
            @include exclude-button();
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            text-align: center;
            box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
            border-radius: 6px;
            > p {
                display: flex;
                align-items: center;
                margin: 0;
                font-size: 14px;
                font-weight: 600;
                color: $darker-gray-color;

                > svg {
                    margin-right: 10px;
                    fill: $light-gray-color;
                }
            }
        }
        .botao-generate {
            @include exclude-button();
            border-radius: 10px;
            padding: 10px 80px;
            text-align: center;
            box-shadow: inset 0px 0px 2px $dark-gray-color-opacity;
            border-radius: 6px;
            > p {
                display: flex;
                align-items: center;
                margin: 0;
                font-size: 14px;
                font-weight: 600;
                color: $darker-gray-color;

                > svg {
                    margin-right: 10px;
                    fill: $light-gray-color;
                }
            }
        }

        .container-b-generate {
            display: flex;
            justify-content: flex-end;
        }

        .n-data {
            margin-top: 20px;
            margin-bottom: 20px;
        }

        .input-padding {
            padding-top: 35px;
        }
</style>
